import { render, staticRenderFns } from "./ButtonsActionForm.vue?vue&type=template&id=61df9b57&"
import script from "./ButtonsActionForm.vue?vue&type=script&lang=js&"
export * from "./ButtonsActionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports